(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[279],{

/***/ 5242:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/informations",
      function () {
        return __webpack_require__(6594);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _Keys_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6528);
/* harmony import */ var _Keys_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Keys_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6511);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3496);





function KeysNewComponent() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("keys").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container align-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
            className: "".concat((_Keys_module_scss__WEBPACK_IMPORTED_MODULE_4___default().keys), " row"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "delivery",
                            srcSet: "https://public.choose.app/website/2023/Delivery@2x.png 2x,https://public.choose.app/website/2023/Delivery@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Delivery.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("delivery")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/Notifications@2x.png 2x,https://public.choose.app/website/2023/Notifications@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Notifications.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("retour")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/Paiement@2x.png 2x,https://public.choose.app/website/2023/Paiement@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Paiement.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("payment")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/ServiceClient@2x.png 2x,https://public.choose.app/website/2023/ServiceClient@3x.png 3x",
                            src: "https://public.choose.app/website/2023/ServiceClient.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("support")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (KeysNewComponent);


/***/ }),

/***/ 6594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _styles_pages_informations_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1813);
/* harmony import */ var _styles_pages_informations_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_informations_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6514);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _new_components_header_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5365);
/* harmony import */ var _new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5374);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3496);
/* harmony import */ var _new_components_home_Keys_Keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8205);
/* harmony import */ var _api_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1936);





// import { observable } from "mobx"





var InformationsScreen = function(props) {
    var getDescription = function getDescription() {
        return "Plus d'informations";
    };
    var getId = function getId() {
        if (router && router.asPath) {
            return router.asPath.replace("/", "").split("?")[0];
        }
        return "";
    };
    var getTitle = function getTitle() {
        return t(getId() + "_title");
    };
    var getText = function getText() {
        return t(getId(), {
            days: props.store === "us" ? 30 : 14
        });
    };
    var getIcon = function getIcon() {
        if (getId() === "shipping") {
            return "DeliveryBig";
        }
        return "ReturnBig";
    };
    var getRedirect = function getRedirect() {
        if (getId() === "shipping") {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "Informations here are only available for the american market"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    children: [
                        "For the european, go",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://choose.notion.site/201651951d7e48ceb142e3bb82a172ee#cc86530da1714c97aefdb6798dbe3fed",
                            children: "here"
                        })
                    ]
                })
            ]
        });
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)([
        "informations"
    ]), t = ref.t, i18n = ref.i18n;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        (0,_api_analytics__WEBPACK_IMPORTED_MODULE_8__/* .trackPage */ .K)("Informations_" + getId());
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_pages_informations_module_scss__WEBPACK_IMPORTED_MODULE_9___default().informations),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                description: getDescription(),
                title: getTitle()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_header_Header__WEBPACK_IMPORTED_MODULE_4__/* .HeaderNewComponent */ .w, {
                disableScroll: true,
                store: props.store,
                language: i18n.language
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_styles_pages_informations_module_scss__WEBPACK_IMPORTED_MODULE_9___default().container), " col-6 col-md-8 col-sm-12"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "https://public.choose.app/website/new/images/".concat(getIcon(), ".png"),
                                srcSet: "https://public.choose.app/website/new/images/".concat(getIcon(), "@2x.png 2x,https://public.choose.app/website/new/images/").concat(getIcon(), "@3x.png 3x")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: getTitle()
                            }),
                            getRedirect(),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: getText()
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                children: t("btn_title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "mailto:contact@appchoose.io",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    children: t("btn")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        className: (_styles_pages_informations_module_scss__WEBPACK_IMPORTED_MODULE_9___default().hr)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_home_Keys_Keys__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                store: props.store
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (InformationsScreen);


/***/ }),

/***/ 6528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"keys":"Keys_keys__HpzY5"};

/***/ }),

/***/ 1813:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"informations":"informations_informations__J2N1t","chase":"informations_chase__ocF6M","sk-chase":"informations_sk-chase__EGIsS","chaseDot":"informations_chaseDot__AV828","sk-chase-dot":"informations_sk-chase-dot__LkMlX","sk-chase-dot-before":"informations_sk-chase-dot-before__e8vmL","hr":"informations_hr__UmxDE","manifesto":"informations_manifesto__ZQPpp","humans":"informations_humans__wd8pr","container":"informations_container__UBT6t","payment":"informations_payment__9PP8q","process":"informations_process__lqiDw","faq":"informations_faq__hL0cE","exemple":"informations_exemple__xKtEW","cards-container":"informations_cards-container__CNUpe","payment-card":"informations_payment-card__SH9Jz","first-in-app":"informations_first-in-app__1uoBO","bold":"informations_bold__ryoh5","contact":"informations_contact__Xirp5","contactImage":"informations_contactImage__64LQZ","camel":"informations_camel__IP7v3"};

/***/ }),

/***/ 6677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5817)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [195,530,774,888,179], function() { return __webpack_exec__(5242); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);